/* Velvety cookie consent banner.
 *
 * Reveals the banner once on first visit (no decision recorded yet),
 * persists Accept / Decline to localStorage so we never show it again
 * for that visitor. We don't actually toggle GA / cookies here — that
 * wiring lives wherever third-party scripts get loaded. This banner
 * just captures the decision and emits a velvety:cookie-consent event
 * so downstream listeners can react.
 */
(function () {
  var KEY = 'velvety-cookie-consent';
  var banner = document.querySelector('[data-velvety-cookie-banner]');
  if (!banner) return;

  function getDecision() {
    try { return localStorage.getItem(KEY); } catch (e) { return null; }
  }

  function setDecision(v) {
    try { localStorage.setItem(KEY, v); } catch (e) {}
    document.dispatchEvent(new CustomEvent('velvety:cookie-consent', { detail: { value: v } }));
  }

  function hideBanner() {
    banner.classList.remove('is-visible');
    setTimeout(function () { banner.hidden = true; }, 260);
  }

  function showBanner() {
    banner.hidden = false;
    // requestAnimationFrame so the transform transitions in cleanly.
    requestAnimationFrame(function () { banner.classList.add('is-visible'); });
  }

  if (getDecision()) return; // already chose — never show again

  showBanner();

  var acceptBtn = banner.querySelector('[data-velvety-cookie-accept]');
  var declineBtn = banner.querySelector('[data-velvety-cookie-decline]');
  if (acceptBtn) acceptBtn.addEventListener('click', function () { setDecision('accepted'); hideBanner(); });
  if (declineBtn) declineBtn.addEventListener('click', function () { setDecision('declined'); hideBanner(); });
})();
